import { useEffect } from 'react';

import { isLogFeatureGateExposureMessage } from '@rovo-extension/feature-gates-adapter';

import { extensionUrl } from '../config/config';
import { manuallyLogExposureSafely } from '../experiment/experimentClient';

/**
 * Relays a chrome-layer experiment's exposure into the live SDK client. Fire-and-forget, no ack.
 * Origin check copied from `useChatBridgeAPI`. Mount once — this listens on `window`, so a second
 * instance would double-log the same exposure.
 */
export function useFeatureGateExposureRelay(): void {
	useEffect(() => {
		const handler = (event: MessageEvent): void => {
			if (event.origin !== extensionUrl || event.source !== window.parent) {
				return;
			}
			if (!isLogFeatureGateExposureMessage(event.data)) {
				return;
			}

			const { key } = event.data;
			manuallyLogExposureSafely(key);
		};

		window.addEventListener('message', handler);
		return (): void => window.removeEventListener('message', handler);
	}, []);
}
